import React, {createContext, type FC, useState} from 'react';

interface BillingAddressContextState {
  country: string;
  line1: string;
  postalCode: string;
  filledAllRequired: boolean;
}

export const BillingAddressContext = createContext<BillingAddressContextState>({
  country: '',
  line1: '',
  postalCode: '',
  filledAllRequired: false,
});

interface BillingAddressContextUpdaterState {
  setCountry: React.Dispatch<React.SetStateAction<string>>;
  setLine1: React.Dispatch<React.SetStateAction<string>>;
  setPostalCode: React.Dispatch<React.SetStateAction<string>>;
}

export const BillingAddressContextUpdater =
  createContext<BillingAddressContextUpdaterState>({
    setCountry: () => {},
    setLine1: () => {},
    setPostalCode: () => {},
  });

const BillingAddressContextProviderComp: FC<{children?: React.ReactNode}> = ({
  children,
}) => {
  const [country, setCountry] = useState<string>('');
  const [line1, setLine1] = useState<string>('');
  const [postalCode, setPostalCode] = useState<string>('');

  return (
    <BillingAddressContext.Provider
      value={{
        country,
        line1,
        postalCode,
        filledAllRequired: [country, line1, postalCode].every(
          required => required !== ''
        ),
      }}>
      <BillingAddressContextUpdater.Provider
        value={{
          setCountry,
          setLine1,
          setPostalCode,
        }}>
        {children}
      </BillingAddressContextUpdater.Provider>
    </BillingAddressContext.Provider>
  );
};

export const BillingAddressContextProvider = React.memo(
  BillingAddressContextProviderComp
);
